import { QUANTITY_PACK } from '../../constants/SkuTypes';
import { IMMEDIATE_UPGRADE } from '../../constants/UsageBasedUpgradePolicies';
export const isMarketingContactsSku = ({
  skuMap,
  skuId
}) => {
  const _isMarketingContactsSku = quantityPack => {
    const {
      quantityPackApiName,
      usageBasedUpgradePolicy
    } = quantityPack;
    return (quantityPackApiName === 'additional-marketing-contacts' || quantityPackApiName === 'additional-legacy-contacts') && usageBasedUpgradePolicy === IMMEDIATE_UPGRADE;
  };
  const sku = skuMap[skuId];
  if (sku.skuType === QUANTITY_PACK) {
    return _isMarketingContactsSku(sku);
  } else {
    const {
      quantityPackDetails
    } = sku;
    return quantityPackDetails.some(quantityPack => _isMarketingContactsSku(quantityPack));
  }
};